import { render } from "./ManageSystemView.vue?vue&type=template&id=365617b2"
import script from "./ManageSystemView.vue?vue&type=script&lang=js"
export * from "./ManageSystemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__